module.exports = __webpack_public_path__ + "img/public/TrustIcons/verifyTickWhite.svg?456090c3";